import {Component, ElementRef, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ComponentAsElement} from "../../services/common/bootstrap/annotation/component-as-element";
import {HttpClient} from "@angular/common/http";
import {LensesService} from "../../services/lenses.service";
import ContactLensForm, {ContactLensEye} from "./model/contact-lens-form";
declare const subscriptionsPdp: any;

type EyePosition = "left" | "right";

export interface LensesInterface {
  deliveryLeadTime?: number,
  deliveryLeadTimeFormatted?: "string",
  flow: string[],
  groupUId?: string,
  purchasable?: boolean,
  rangeUId?: string,
  values: string[];
  codes?: string[];
}

class Eye {
  constructor(
    public position: EyePosition,
    public values: string[],
    public disable: boolean = false
  ) {

  }

  selected: boolean;
  selectValue: string;

  setSelect(_selectValue) {
    if (!this.selected && _selectValue === null) {
      this.selected = false;
    } else {
      this.selected = true;
    }

    this.selectValue = _selectValue;

    return this;
  }

  setDisable(_disable: boolean = false) {
    this.disable = _disable;
  }

  setDefault(resolveSelected) {
    this.setSelect(resolveSelected ? this.selectValue : null);
  }

  isSelected() {
    return !!this.selectValue;
  }

  updateValues(_values: string[]) {
    this.selected = false;
    this.values = _values;
  }

  showDefaultValue() {
    return this.selected;
  }

  clear() {
    this.disable = false;
    this.selectValue = '';
  }
}

class Lense {
  constructor(
    public flow: string = '',
    public leftValues: string[] = [],
    public rightValues: string[] = [],
    public index: number,
    public code: string
  ) {
    this.left = new Eye('left', leftValues);
    this.right = new Eye('right', rightValues);

    if (this.index === 0) {
      if (this.leftValues.length === 1) {
        this.left.setSelect(this.leftValues[0] || '').setDisable(true);
      }

      if (this.rightValues.length === 1) {
        this.right.setSelect(this.rightValues[0] || '').setDisable(true);
      }
    }
  }

  public left: Eye;
  public right: Eye;

  public setDisable(_flag: boolean) {
    this.left.setDisable(_flag);
    this.right.setDisable(_flag);
  }

  public updateDisable() {
    this.left.setDisable(!this.left.values.length);
    this.right.setDisable(!this.right.values.length);
  }
}

// class Counter {
//   constructor(
//     public maxLense: number,
//   ) {
//
//   }
//
//   count: number = 1;
//
//   increment() {
//     if (this.count >= this.maxLense) {
//       return;
//     }
//
//     this.count++;
//   }
//
//   decrement() {
//     if (this.count <= 1) {
//       return;
//     }
//
//     this.count--;
//   }
//
//   showDecrementBtn() {
//     return this.count > 1;
//   }
//
//   showIncrementBtn() {
//     return this.count < this.maxLense;
//   }
//
//   reset() {
//     this.count = 1;
//   }
// }

@ComponentAsElement('v-lenses-configurator-element')
@Component({
  selector: 'v-lenses-configurator',
  templateUrl: './lenses-configurator.component.html',
  styleUrls: []
})
export class LensesConfiguratorComponent {
  @Input() productCode: string;
  @Input() cl: string;
  @Input() paramSubscription: string;
  public lense: Lense[] = [];
  public formData: ContactLensForm;
  readonly MAX_LENSES = 8;
  public productCl: (null|string)[] =  [];
  public firstTimeDelivery: number;
  public deliveryLeadTimeText: null|string = null;
  private firstDeliveryLeadTimeText: null|string = null;
  private deliveryLeadTimeHolder = [
    {
      lense: 'left',
      purchasable: false,
      deliveryTime: -1,
      deliveryText: null
    },
    {
      lense: 'right',
      purchasable: false,
      deliveryTime: -1,
      deliveryText: null
    }
  ];
  private isDatalayer: boolean;
  private isInsider = false;

  @Output()
  private clFormChanged: EventEmitter<boolean> = new EventEmitter();

  constructor(
    private http: HttpClient,
    private el: ElementRef,
    private lensesService: LensesService
  ) { }

  ngOnInit() {
    this.formData = new ContactLensForm(this.productCode, false);

    if(window['insider_object']) {
      this.isInsider = true;
    }

    this.lensesService.getLenses(this.productCode).subscribe((data: LensesInterface) => {
      this.firstTimeDelivery = data.deliveryLeadTime;

      if(data.deliveryLeadTimeFormatted) {
        this.deliveryLeadTimeText = data.deliveryLeadTimeFormatted;
        this.firstDeliveryLeadTimeText = data.deliveryLeadTimeFormatted;
        this.deliveryLeadTimeHolder.forEach((lense, index) => {
          this.deliveryLeadTimeHolder[index].deliveryTime = data.deliveryLeadTime;
          this.deliveryLeadTimeHolder[index].deliveryText = data.deliveryLeadTimeFormatted;
        });
      }

      // clear right lense delivery time in edit of subscription, to avoid overwriting left lense delivery time
      if(this.paramSubscription) {
        this.deliveryLeadTimeHolder[1].deliveryTime = -1;
        this.deliveryLeadTimeHolder[1].deliveryText = null;
      }

      for (let index = 0; index < data.flow.length; index++) {
        const flowName: string = data.flow[index];
        const values = data.values;
        const code: string = data.codes[index];

        if (index === 0) {
          this.lense.push(
            new Lense(flowName, values, values, index, code)
          )
        } else {
          this.lense.push(
            new Lense(flowName, [], [], index, code)
          )
        }

      }

      if(this.cl) {
        this.clExist();
      }
      else {
        this.updateNextLensValues(this.lense[0], 'left');
        if(!this.paramSubscription) {
          this.updateNextLensValues(this.lense[0], 'right');
        }
        this.updateDisableInit();
        if(this.isInsider && this.lense[0].leftValues.length === 1 && this.lense[0].rightValues.length === 1) {
          this.setInsiderParameter(this.lense[0].leftValues[0], 'left', this.lense[0].code);
          this.setInsiderParameter(this.lense[0].rightValues[0], 'right', this.lense[0].code);
        }
      }
    });

    if(window['addToCartData'] && window['addToCartData'][this.formData.productCode]) {
      this.isDatalayer = true;
      window['addToCartData'][this.formData.productCode]['ecommerce']['add']['products'][0]['dimension18'] = '0';
      this.updateQuantityDatalayer();
    }
  }

  private setInsiderParameter(_value, _type, _code) {
    const type = _type[0].toUpperCase() + _type.slice(1);
    const code = _code;

    window['insider_object']['product']['custom'][`${code}${type}`] = _value;
  }

  private clExist() {
    this.productCl = this.cl.split(',');
    this.productCl.forEach((_cl: string, _index: number) => {
      const index: number = _index;
      const cl: string = _cl;

      this.onChange(cl, 'left', index);
      if(!this.paramSubscription) {
        this.onChange(cl, 'right', index);
      }
    });
  }

  updateDeliveryDatalayer(_deliveryTime) {
    const deliveryTime = _deliveryTime;

    if(deliveryTime === -1) {
      window['addToCartData'][this.formData.productCode]['ecommerce']['add']['products'][0]['dimension7'] = 'n/a';
    }
    else {
      window['addToCartData'][this.formData.productCode]['ecommerce']['add']['products'][0]['dimension7'] = deliveryTime.toString();
    }
  }

  updateInsider(_type, _range, _groupId) {
    const type = _type;
    const range = _range;
    const groupId = _groupId;
    const eyesIdential = this.formData.eyesIdentical;

    window['insider_object']['product']['custom']['eyesIdentical'] = eyesIdential;

    if(type === 'left') {
      window['insider_object']['product']['custom']['rangeUidLeft'] = range;
      window['insider_object']['product']['custom']['rangeGroupUidLeft'] = groupId;

      if(eyesIdential) {
        for(const key in window['insider_object']['product']['custom']) {
          if(key.slice(-5).toLowerCase() === 'right') {
            delete window['insider_object']['product']['custom'][key];
          }
        }
      }
    }
    else {
      window['insider_object']['product']['custom']['rangeUidRight'] = range;
      window['insider_object']['product']['custom']['rangeGroupUidRight'] = groupId;
    }
  }

  updateQuantityDatalayer() {
    const sum = this.formData.eyesIdentical ? this.formData.leftEye.quantity : this.formData.leftEye.quantity + this.formData.rightEye.quantity;

    window['addToCartData'][this.formData.productCode]['ecommerce']['add']['products'][0]['quantity'] = sum.toString();
  }

  updateConfigdiffDatalayer() {
    if(this.formData.eyesIdentical || this.formData.leftEye.rangeUid === this.formData.rightEye.rangeUid) {
      window['addToCartData'][this.formData.productCode]['ecommerce']['add']['products'][0]['dimension18'] = '0';
    }
    else {
      window['addToCartData'][this.formData.productCode]['ecommerce']['add']['products'][0]['dimension18'] = '1';
    }
  }

  updateDisableInit() {
    this.updateDisable(this.lense[0], 'left');
    this.updateDisable(this.lense[0], 'right');
  }

  updateDeliveryLeadText() {
    this.deliveryLeadTimeText = this.firstDeliveryLeadTimeText;
    this.deliveryLeadTimeHolder.forEach((lense, index) => {
      this.deliveryLeadTimeHolder[index].deliveryTime = -1;
      this.deliveryLeadTimeHolder[index].deliveryText = this.firstDeliveryLeadTimeText;
      this.deliveryLeadTimeHolder[index].purchasable = false;
      if(this.isDatalayer) {
        this.updateDeliveryDatalayer(this.firstTimeDelivery);
      }
    });
  }

  countDeliveryLeadTime() {
    if(this.deliveryLeadTimeHolder.every(lense => lense.purchasable === true)) {
      const maxTimeDelivery = Math.max(this.deliveryLeadTimeHolder[0].deliveryTime, this.deliveryLeadTimeHolder[1].deliveryTime);
      this.deliveryLeadTimeHolder.some(lense => {
        if(lense.deliveryTime === maxTimeDelivery) {
          this.deliveryLeadTimeText = lense.deliveryText;
          if(this.isDatalayer) {
            this.updateDeliveryDatalayer(lense.deliveryTime);
          }
          return true;
        }
      });
    }
    else if(this.deliveryLeadTimeHolder.some(lense => lense.purchasable === true)) {
      this.deliveryLeadTimeHolder.forEach(lense => {
        if(lense.purchasable === true) {
          this.deliveryLeadTimeText = lense.deliveryText;
          if(this.isDatalayer) {
            this.updateDeliveryDatalayer(lense.deliveryTime);
          }
        }
      });
    }
    else {
      if(this.deliveryLeadTimeText !== this.firstDeliveryLeadTimeText) {
        this.updateDeliveryLeadText();
      }
    }
  }

  resetLensSelections(eyesIdentical) {
    this.formData = new ContactLensForm(this.productCode, eyesIdentical);
    this.updateDefaultValuesForAll();
    this.updateDisableInit();
    this.resetQuantity(this.formData.leftEye);
    this.resetQuantity(this.formData.rightEye);
    this.updateDeliveryLeadText();
    if(this.isInsider) {
      this.formData.eyesIdentical ?
        delete window['insider_object']['product']['custom'][`${this.lense[0].code}Right`]
        : this.setInsiderParameter(this.lense[0].rightValues[0], 'right', this.lense[0].code);
    }
    this.el.nativeElement.dispatchEvent(new CustomEvent("clFormChanged", {
      detail: false,
      bubbles: true
    }));
    this.countRecommendations();
  }

  resetQuantity(eyeForm: ContactLensEye) {
    eyeForm.quantity = 1;
  }
  incQuantity(eyeForm: ContactLensEye, _type: EyePosition) {
    let quantity = eyeForm.quantity + 1;

    eyeForm.quantity = Math.min(quantity, this.MAX_LENSES);
    if(this.isDatalayer) {
      this.updateQuantityDatalayer();
    }
    this.countRecommendations();
    this.updateNextLensValues(this.lense[this.lense.length - 1], _type);
  }
  decQuantity(eyeForm: ContactLensEye, _type: EyePosition) {
    let quantity = eyeForm.quantity - 1;

    eyeForm.quantity = Math.max(quantity, 1);
    if(this.isDatalayer) {
      this.updateQuantityDatalayer();
    }
    this.countRecommendations();
    this.updateNextLensValues(this.lense[this.lense.length - 1], _type);
  }
  showDecButton(eyeForm: ContactLensEye): boolean {
    return eyeForm.quantity > 1;
  }
  showIncButton(eyeForm: ContactLensEye): boolean {
    return eyeForm.quantity < this.MAX_LENSES;
  }

  getNextLense(_lense) {
    if (this.lense[_lense.index + 1]) {
      return this.lense[_lense.index + 1];
    }

    return null;
  }

  private formChanged(form: ContactLensForm) {
    let valid = this.isFormValid(form);
    this.el.nativeElement.dispatchEvent(new CustomEvent("clFormChanged", {
      detail: valid,
      bubbles: true
    }));
  }

  private isFormValid(form: ContactLensForm): boolean {
    let formEyeValid = (formEye: ContactLensEye) => {
      return !!formEye.groupUid
        && formEye.rangeUid
        && formEye.quantity > 0;
    };
    let mandatoryAttributesValid = !!form.productCode && formEyeValid(form.leftEye);
    let rightEyeValid = !!this.paramSubscription || form.eyesIdentical || formEyeValid(form.rightEye);

    return mandatoryAttributesValid && rightEyeValid && !this.isSameContactLensSelected();
  }

  private isSameContactLensSelected() {
    if (this.paramSubscription && this.cl && this.productCl.length > 0) {
      const values: string[] = this.getValuesFromEye('left', this.productCl.length);
      return this.productCl.length == values.length && this.productCl.every((el, ix) => el === values[ix])
    }
    return false;
  }

  private updateNextLensValues(_lense: Lense, _type: EyePosition) {
    const values: string[] = this.getValuesFromEye(_type, _lense.index);
    const quantity: number = _type == "left" ? this.formData.leftEye.quantity : this.formData.rightEye.quantity;
    if (!values.length) {
      return;
    }

    this.lensesService.getLenses(this.formData.productCode + '?values=' + values.join(',') + '&quantity=' + quantity).subscribe((data: LensesInterface) => {

      const nextLense = this.getNextLense(_lense);
      let formEye = _type == "left" ? this.formData.leftEye : this.formData.rightEye;
      let secondFormEye = null;

      if (this.productCl.length) {
        secondFormEye = _type === 'left' ? this.formData.rightEye : this.formData.leftEye;
      }

      if (!!nextLense) {
        nextLense[_type].updateValues(data.values);
        this.clearFormData(formEye);

        if (secondFormEye) {
          const secondType = _type === 'left' ? 'right' : 'left';
          nextLense[secondType].updateValues(data.values);
          this.clearFormData(secondFormEye);
        }

      }
      else if (data.rangeUId && data.groupUId) {
        formEye.rangeUid = data.rangeUId;
        formEye.groupUid = data.groupUId;

        if (secondFormEye) {
          secondFormEye.rangeUid = data.rangeUId;
          secondFormEye.groupUid = data.groupUId;
        }
        if(this.isDatalayer) {
          this.updateConfigdiffDatalayer();
        }
        if(this.isInsider) {
          this.updateInsider(_type, data.rangeUId, data.groupUId);
        }
      }

      if (!secondFormEye) {
        this.formChanged(this.formData);
      }
      else if(_lense.index === this.productCl.length-1) {
        this.formChanged(this.formData);
      }

      // clear right lense delivery time in edit of subscription, to avoid overwriting left lense delivery time
      if(this.paramSubscription) {
        this.deliveryLeadTimeHolder[1].deliveryTime = -1;
        this.deliveryLeadTimeHolder[1].deliveryText = null;
      }

      if (_type === 'left') {
        typeof(data.deliveryLeadTime) === 'number' ? this.deliveryLeadTimeHolder[0].deliveryTime = data.deliveryLeadTime : this.deliveryLeadTimeHolder[0].deliveryTime = -1;
        data.deliveryLeadTimeFormatted ? this.deliveryLeadTimeHolder[0].deliveryText = data.deliveryLeadTimeFormatted : this.deliveryLeadTimeHolder[0].deliveryText = null;
        data.purchasable ? this.deliveryLeadTimeHolder[0].purchasable = true : this.deliveryLeadTimeHolder[0].purchasable = false;
      }
      if (_type === 'right') {
        typeof(data.deliveryLeadTime) === 'number' ? this.deliveryLeadTimeHolder[1].deliveryTime = data.deliveryLeadTime : this.deliveryLeadTimeHolder[1].deliveryTime = -1;
        data.deliveryLeadTimeFormatted ? this.deliveryLeadTimeHolder[1].deliveryText = data.deliveryLeadTimeFormatted : this.deliveryLeadTimeHolder[1].deliveryText = null;
        data.purchasable ? this.deliveryLeadTimeHolder[1].purchasable = true : this.deliveryLeadTimeHolder[1].purchasable = false;
      }

      this.countDeliveryLeadTime();
    });
  }


  private clearFormData(eye: ContactLensEye) {
    eye.groupUid = null;
    eye.rangeUid = null;
  }

  updateDisable(_lense: Lense, _type: EyePosition) {
    const index = _lense.index;
    const indexNext = index + 1;
    let lastLense: Lense;

    for (let i = 0; i < this.lense.length; i++) {
      const lenseParams = this.lense[i];
      let eye: Eye = lenseParams[_type];

      if (lenseParams.index < index) {
        eye.setDisable(!eye.isSelected());
      } else if (lenseParams.index === index) {
        eye.setDisable(false);
      } else if (lenseParams.index === indexNext) {

        if (lastLense) {
          let eyeLast: Eye = lastLense[_type];

          if (eyeLast.isSelected()) {
            eye.setDisable(false);
          } else {
            eye.setDisable(true);
          }

          continue;
        }

        eye.setDisable(false);
      } else {
        eye.setDisable(true);
      }

      lastLense = _lense;
    }

  }

  getValuesFromEye(_type: EyePosition, _index: number) {
    let values = [];

    for (let lense of this.lense) {
      if (lense.index <= _index && !!lense[_type].selectValue) {
        values.push(lense[_type].selectValue);
      }
    }

    return values;
  }

  updateDefaultValuesForAll() {
    for (let i = 0; i < this.lense.length; i++) {
      let lense = this.lense[i];

      let eyeLeft: Eye = lense['left'];
      let eyeRight: Eye = lense['right'];

      eyeLeft.setDefault(i === 0);
      eyeRight.setDefault(i === 0);
    }
  }

  updateDefaultValues(_lense: Lense, _type: EyePosition) {
    for (let i = _lense.index + 1; i < this.lense.length; i++) {
      let lense = this.lense[i];
      let eye: Eye = lense[_type];

      eye.setDefault(false);
    }
  }

  onChange(_value: string, _type: EyePosition, _index: number, _code?: string) {
    const lense = this.lense[_index];

    if(JSON.parse(_value) === null) return;

    if (lense[_type]) {
      lense[_type].setSelect(_value);
    }

    this.updateNextLensValues(lense, _type);
    this.updateDisable(lense, _type);
    this.updateDefaultValues(lense, _type);
    if(this.isInsider) {
      this.setInsiderParameter(_value, _type, _code);
    }
  }

  private countRecommendations() {
    const eyesIdentical = this.formData.eyesIdentical;
    const quantity = eyesIdentical ? this.formData.leftEye.quantity : Math.min(this.formData.leftEye.quantity, this.formData.rightEye.quantity);

    subscriptionsPdp['countRecommendations'](eyesIdentical, quantity);
  }
}
